import React, { useState } from 'react';
import { useI18n } from '../../i18n';
import { buildSharePayload } from './SocialShareButtons';
import { showShareToast } from './shareToast';

function invitePayload(t) {
  const url = new URL('/', window.location.origin).href;
  return buildSharePayload({
    url,
    title: t('betaInvite.shareTitle'),
    text: t('betaInvite.shareText'),
  });
}

export default function BetaInviteCard({ compact = false }) {
  const { t } = useI18n();
  const [copied, setCopied] = useState(false);
  const payload = invitePayload(t);
  const encodedTitle = encodeURIComponent(payload.title);
  const encodedText = encodeURIComponent(payload.fullText);
  const whatsappHref = `https://api.whatsapp.com/send?text=${encodedText}`;
  const emailHref = `mailto:?subject=${encodedTitle}&body=${encodedText}`;

  async function copyInvite() {
    try {
      await navigator.clipboard.writeText(payload.fullText);
      setCopied(true);
      showShareToast(t('share.copyToast'));
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  }

  async function nativeShare() {
    if (!navigator.share) return copyInvite();
    try {
      await navigator.share({
        title: payload.title,
        text: payload.text,
        url: payload.url,
      });
    } catch {
      await copyInvite();
    }
  }

  return (
    <article className={`ct-beta-invite-card${compact ? ' compact' : ''}`}>
      <div className="ct-beta-invite-head">
        <span>{t('beta.badge')}</span>
        <i className="ph ph-sparkle"></i>
      </div>
      <h2>{t('betaInvite.title')}</h2>
      <p>{t('betaInvite.copy')}</p>
      <div className="ct-beta-invite-actions">
        <a href={whatsappHref} target="_blank" rel="noopener noreferrer">
          <i className="ph ph-whatsapp-logo"></i>
          <span>{t('betaInvite.whatsapp')}</span>
        </a>
        <a href={emailHref}>
          <i className="ph ph-envelope"></i>
          <span>{t('betaInvite.email')}</span>
        </a>
        <button type="button" onClick={copyInvite}>
          <i className={copied ? 'ph ph-check' : 'ph ph-link-simple'}></i>
          <span>{copied ? t('share.copyDone') : t('betaInvite.copyLink')}</span>
        </button>
        <button type="button" onClick={nativeShare}>
          <i className="ph ph-share-network"></i>
          <span>{t('betaInvite.native')}</span>
        </button>
      </div>
    </article>
  );
}
